/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RequestItemStatus = {
    Needed: 'needed',
    Received: 'received',
    Fulfilled: 'fulfilled',
    Withdrawn: 'withdrawn',
} as const;
export type RequestItemStatus = typeof RequestItemStatus[keyof typeof RequestItemStatus];


export function instanceOfRequestItemStatus(value: any): boolean {
    for (const key in RequestItemStatus) {
        if (Object.prototype.hasOwnProperty.call(RequestItemStatus, key)) {
            if (RequestItemStatus[key as keyof typeof RequestItemStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RequestItemStatusFromJSON(json: any): RequestItemStatus {
    return RequestItemStatusFromJSONTyped(json, false);
}

export function RequestItemStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestItemStatus {
    return json as RequestItemStatus;
}

export function RequestItemStatusToJSON(value?: RequestItemStatus | null): any {
    return value as any;
}

export function RequestItemStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): RequestItemStatus {
    return value as RequestItemStatus;
}

